// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oc-1";
export var messageSideRight = "_oc-2";
export var subscribeToBackInStockBubbleContainer = "_oc-0";